import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "展示管理 ", -1);

const _hoisted_3 = {
  class: "base_details_content_second"
};
const _hoisted_4 = {
  class: "ci_info_footer"
};
import { reactive, ref } from "vue";
import $ from "@util/base";
import api from "@api/partnershipInfo";
import { $msg } from "@ui/msg";
import QuillEditor from "@com/QuillEditor";
import UploadPicture from "@com/upload/UploadPicture.vue";
export default {
  __name: 'PartnershipInfo',

  setup(__props) {
    const form = reactive({
      id: null,
      teamBuildingBannerPic: '',
      teamBuildingPic: '',
      linePic: '',
      lineSharePic: '',
      partnershipPic: ''
    });
    const rules = {
      teamBuildingPic: [{
        required: true,
        message: '请上传团建介绍主图',
        trigger: 'blur'
      }],
      linePic: [{
        required: true,
        message: '请上传线路主图',
        trigger: 'blur'
      }],
      lineSharePic: [{
        required: true,
        message: '请上传线路分享主图',
        trigger: 'blur'
      }],
      partnershipPic: [{
        required: true,
        message: '请上传企业合作主图',
        trigger: 'blur'
      }]
    };
    const formRef = ref(null);
    const isEdit = ref(false);

    const submitForm = async formEl => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          // 有id为编辑
          let data = $.deepCopy(form);
          api.update(data, () => {
            $msg.succ("修改成功");
            getCompany();
          });
        }
      });
    };

    getCompany();

    function getCompany() {
      api.list(val => {
        form.id = val.id;
        form.teamBuildingBannerPic = [val.teamBuildingBannerPic];
        form.teamBuildingPic = [val.teamBuildingPic];
        form.linePic = [val.linePic];
        form.lineSharePic = [val.lineSharePic];
        form.partnershipPic = [val.partnershipPic];
      });
      cancel();
    }

    function cancel() {
      isEdit.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_container = _resolveComponent("el-container");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createBlock(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "140px",
          class: "base_details_form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "团建首页banner图",
            prop: "logo"
          }, {
            default: _withCtx(() => [_createVNode(UploadPicture, {
              modelValue: form.teamBuildingBannerPic,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.teamBuildingBannerPic = $event),
              imgSize: '750*170',
              limit: 1,
              fileSize: _unref($).imgFileSize(),
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "fileSize", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "公司介绍主图",
            prop: "logo"
          }, {
            default: _withCtx(() => [_createVNode(UploadPicture, {
              modelValue: form.teamBuildingPic,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.teamBuildingPic = $event),
              imgSize: '750*360',
              limit: 1,
              fileSize: _unref($).imgFileSize(),
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "fileSize", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "线路安排主图",
            prop: "logo"
          }, {
            default: _withCtx(() => [_createVNode(UploadPicture, {
              modelValue: form.linePic,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.linePic = $event),
              imgSize: '750*360',
              limit: 1,
              fileSize: _unref($).imgFileSize(),
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "fileSize", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "案例分享主图",
            prop: "logo"
          }, {
            default: _withCtx(() => [_createVNode(UploadPicture, {
              modelValue: form.lineSharePic,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.lineSharePic = $event),
              imgSize: "'750x*'",
              limit: 1,
              fileSize: _unref($).imgFileSize(),
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "fileSize", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合作企业主图",
            prop: "logo"
          }, {
            default: _withCtx(() => [_createVNode(UploadPicture, {
              modelValue: form.partnershipPic,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.partnershipPic = $event),
              imgSize: "'750x*'",
              limit: 1,
              fileSize: _unref($).imgFileSize(),
              disabled: !isEdit.value
            }, null, 8, ["modelValue", "fileSize", "disabled"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_4, [!isEdit.value ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: _cache[5] || (_cache[5] = $event => isEdit.value = true),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("编辑")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('MODIFY')]]) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: _cache[6] || (_cache[6] = $event => submitForm(formRef.value)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        })), isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })) : _createCommentVNode("", true)])])])]),
        _: 1
      });
    };
  }

};